import { gql } from '@apollo/client';

export const genericTextBlockFragment = gql`
  fragment genericTextBlock on GenericTextBlock {
    __typename
    sys {
      ...sys
    }
    bodyContent {
      ...genericTextBlockRT
    }
  }

  fragment genericTextBlockRT on GenericTextBlockBodyContent {
    json
    links {
      ...genericTextBlockRTLinks
    }
  }

  fragment genericTextBlockRTLinks on GenericTextBlockBodyContentLinks {
    entries {
      block {
        sys {
          ...sys
        }
        ...mediaImage
        ...mediaVideo
        ...gallery
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }
`;
